import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconEllipsis = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "#5f6567"} className={`ellipsis ${props.className}`} viewBox="0 0 500 500">
        <circle cx="50" cy="250" r="50" />
        <circle cx="450" cy="250" r="50" />
        <circle cx="250" cy="250" r="50" />
    </IconWrapper>
);

export default memo(IconEllipsis);
